import { FLOWS_CONFIG_PATH } from '@flows/src/FlowsConfigRouter';
import { useRouteMatch } from 'react-router';

export interface FlowsRouteParams {
  flowId?: string;
  insuranceId?: string;
}

interface RouteParams {
  flowId: string;
  insuranceId: string;
}

/**
 * Will only return a valid while inside a flows configure route
 */
export const useFlowsConfigureParams = (): FlowsRouteParams => {
  const { params } =
    useRouteMatch<RouteParams>(
      `${FLOWS_CONFIG_PATH}/:flowId/insurances/:insuranceId?`,
    ) || {};

  return {
    flowId: params?.flowId,
    insuranceId: params?.insuranceId,
  };
};
